<template>
  <div class="scroll-to-top"
       v-scroll-to="'body'"
       v-show="show">
    <icon-arrow-up class="icon-arrow-up"
                   width="16"
                   height="18"
                   icon-color="#949494" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false
      }
    },

    methods: {
      handleScroll() {
        this.show = window.scrollY > 200
      }
    },

    created () {
      window.addEventListener('scroll', this.handleScroll)
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style lang="scss" scoped>
  .scroll-to-top {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 40px;
    bottom: 40px;
    width: 40px;
    height: 40px;

    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;

    cursor: pointer;
    transition: 0.2s all;

    &:hover {
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
      background: rgba(244, 244, 244, 0.9);
    }

    &:active {
      box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2);
      background: rgba(239, 239, 239, 0.9);
    }
  }
</style>
